export default "__VITE_ASSET__Di49kdXY__"